import * as React from 'react';

const Bell24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.5 17.5c0-2.08 1.71-3.18 1.77-3.21l.73-.44V9a5.5 5.5 0 0 1 11 0v4l.01.84.7.44a4.01 4.01 0 0 1 1.79 3.22zm8 3a2.5 2.5 0 0 1-2.29-1.5h4.58a2.5 2.5 0 0 1-2.29 1.5m7-7.5V9a7 7 0 1 0-14 0v4S3 14.5 3 17.5c0 .83.67 1.5 1.5 1.5h4.14a4 4 0 0 0 7.72 0h4.14c.83 0 1.5-.67 1.5-1.5 0-3-2.5-4.5-2.5-4.5" }));
Bell24.Size = 24;
Bell24.Title = "Bell";

export { Bell24 as default };
